var map = {
	"./personality-relax-beijing.webm": "6ecc",
	"./personality-relax-bingdao.webm": "b64d",
	"./personality-relax-riben.webm": "443b",
	"./personality-relax-shenzhen.webm": "fe3a",
	"./personality-relax-taiguo.webm": "2b5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07612";